import VMasker from 'vanilla-masker/lib/vanilla-masker';

const telMask = ['(99) 9999-99999', '(99) 99999-9999'];

const MaskPhone = (masks, max, event) => {
    const c = event.target;
    const v = c.value.replace(/\D/g, '');
    const m = c.value.length > max ? 1 : 0;

    VMasker(c).unMask();
    VMasker(c).maskPattern(masks[m]);
    c.value = VMasker.toPattern(v, masks[m]);
}

export {
    telMask,
    MaskPhone
};